import { joinMobileNumberList, parseMobileNumberList } from "./phoneNumberUtils";

const AMOUNT_SCALE = 3;

const roundAmount = (value) => Number(value.toFixed(AMOUNT_SCALE));

export const splitTotalAmount = (totalAmount, installmentCount) => {
  const total = Number(totalAmount);
  const count = Number(installmentCount);
  if (!Number.isFinite(total) || total <= 0 || !Number.isInteger(count) || count <= 0) {
    return [];
  }

  const factor = 10 ** AMOUNT_SCALE;
  const totalMinor = Math.round(total * factor);
  const baseMinor = Math.floor(totalMinor / count);
  const remainderMinor = totalMinor - baseMinor * count;
  const amounts = [];

  for (let index = 0; index < count; index += 1) {
    const minor = index === count - 1 ? baseMinor + remainderMinor : baseMinor;
    amounts.push(roundAmount(minor / factor));
  }

  return amounts;
};

export const nextDueDate = (currentDate, frequency) => {
  const date = new Date(`${currentDate}T00:00:00`);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  switch (frequency) {
    case "ONE_TIME":
      return formatDate(date);
    case "WEEKLY":
      date.setDate(date.getDate() + 7);
      return formatDate(date);
    case "MONTHLY":
      date.setMonth(date.getMonth() + 1);
      return formatDate(date);
    case "YEARLY":
      date.setFullYear(date.getFullYear() + 1);
      return formatDate(date);
    default:
      return formatDate(date);
  }
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const subtractDays = (isoDate, days) => {
  const date = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  date.setDate(date.getDate() - Number(days || 0));
  return formatDate(date);
};

export const generateAccountPlanPreview = ({
  totalAmount,
  frequency,
  installmentCount,
  startDate,
  reminderDaysBefore,
}) => {
  const count = frequency === "ONE_TIME" ? 1 : Number(installmentCount);
  const amounts = splitTotalAmount(totalAmount, count);
  if (!amounts.length || !startDate) {
    return [];
  }

  const preview = [];
  let dueDate = startDate;
  for (let number = 1; number <= count; number += 1) {
    preview.push({
      installmentNumber: number,
      dueDate,
      reminderDate: subtractDays(dueDate, reminderDaysBefore),
      amount: amounts[number - 1],
    });
    dueDate = nextDueDate(dueDate, frequency);
  }
  return preview;
};

export const joinMobileNumbers = joinMobileNumberList;

export const parseMobileNumbers = parseMobileNumberList;

export const resolveTotalAmount = (plan) => {
  if (!plan) {
    return "";
  }
  if (plan.totalAmount != null && plan.totalAmount !== "") {
    return String(plan.totalAmount);
  }
  const perInstallment = Number(plan.installmentAmount);
  const count = Number(plan.installmentCount);
  if (Number.isFinite(perInstallment) && Number.isFinite(count) && count > 0) {
    return roundAmount(perInstallment * count).toFixed(AMOUNT_SCALE);
  }
  return "";
};
